( function( $ ) {

	var Banner = { };

	Banner.scrollTo = function() {
		$( '#home .banner' ).find( '.theme-btn' ).on( 'click', function( e ) {
			e.preventDefault();
			$( 'html,body' ).animate( {
				scrollTop: $( "#index-archive" ).offset().top
			} );
		} );
	};

	Banner.setHeight = function() {
		var navigationHeight = $( '.navbar-static-top' ).height();
		var windowHeight = $( window ).height();
		var bannerHeight = windowHeight - navigationHeight;
		
		$( '#error404-page .banner' ).css( { 'min-height': bannerHeight } );
	};

	$( document ).ready( function() {
		Banner.scrollTo();
		Banner.setHeight();

		$( ".rslides" ).responsiveSlides( {
			pager: true
		} );
	} );

	$( window ).resize( function() {
		Banner.setHeight();
	} );

} )( jQuery );
